var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDoc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    width: "20px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "office-file-doc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77995",
    "data-name": "Path 77995",
    d: "M4.5,18.667A2.667,2.667,0,0,0,7.167,16V14.667A2.667,2.667,0,0,0,4.5,12Z",
    transform: "translate(-0.417 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77996",
    "data-name": "Path 77996",
    d: "M11.833,12A1.333,1.333,0,0,0,10.5,13.333v4a1.333,1.333,0,1,0,2.667,0v-4A1.333,1.333,0,0,0,11.833,12Z",
    transform: "translate(-1.083 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77997",
    "data-name": "Path 77997",
    d: "M19.167,12A2.667,2.667,0,0,0,16.5,14.667V16a2.667,2.667,0,0,0,2.667,2.667",
    transform: "translate(-1.75 -1.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77998",
    "data-name": "Path 77998",
    d: "M20.359,5.024a1.333,1.333,0,0,1,.39.942V18.75a2,2,0,0,1-2,2h-16a2,2,0,0,1-2-2v-16a2,2,0,0,1,2-2H15.53a1.333,1.333,0,0,1,.943.39Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77999",
    "data-name": "Path 77999",
    d: "M17.249.748v4a1.333,1.333,0,0,0,1.333,1.333h4",
    transform: "translate(-1.833 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/doc.d8207c9e.svg";
export { ForwardRef as ReactComponent };